const { getPubNubInstance } = require('pubnub-subscribe');

const onlyUnique = (value, index, self) => self.indexOf(value) === index;

const deps = [require('data/actions/pubnub').name];

module.exports = angular
  .module('bench.data.service.pubnub', deps)
  .factory('BlPubnub', ($rootScope, PubnubActions) => {
    class BlPubnub {
      subscriptions = [];

      onMessage({ channel, message }) {
        const clientId = channel.split('.')[1];

        const dispatch = (name, detail) => {
          window.dispatchEvent(new CustomEvent(name, { detail }));
        };

        $rootScope.$apply(() => {
          dispatch(PubnubActions.event(message.name), message);

          if (message.name === 'feed.message.created') {
            dispatch(PubnubActions.messageCreated({ clientId }), message);
          }
          if (message.name === 'feed.message.edited') {
            dispatch(PubnubActions.messageEdited({ clientId }), message);
          }
          if (message.name === 'event.categorization.requested') {
            dispatch(PubnubActions.categorizationRequested({ clientId }), message);
          }
        });
      }

      async init() {
        if (this.pubNubInstance) {
          return this.pubNubInstance;
        }
        this.pubNubInstance = await getPubNubInstance();
        return this.pubNubInstance;
      }

      /**
       * Gets a flat array of unique channels from an array of subscriptions
       * @param {Array.<Subscription>} subscriptions
       * @returns {Array.<String>}
       */
      getUniqueChannelsInSubscriptions(subscriptions) {
        return subscriptions.flatMap(sub => sub.channels).filter(onlyUnique);
      }

      /**
       * Checks the given channels for new ones and uses the PubNub client to open
       * a new connection for them if there are any.
       * @param {Array.<String>} channels
       */
      addNewChannelsToClient(channels) {
        const subscribedChannels = this.getUniqueChannelsInSubscriptions(
          this.pubNubInstance.subscriptions,
        );
        const newChannels = channels
          .filter(onlyUnique)
          .filter(channel => !subscribedChannels.includes(channel));
        if (newChannels.length) {
          this.pubNubInstance.client.subscribe({ channels: newChannels });
        }
      }

      /**
       * Checks the given channels for new ones and uses the PubNub client to open
       * a new connection for them if there are any.
       * @param {String|Array.<String>} channel
       */
      async subscribe(channel) {
        try {
          await this.init();
          const channels = [].concat(channel);
          this.addNewChannelsToClient(channels);
          if (!this.listener) {
            this.listener = { message: this.onMessage };
            this.pubNubInstance.client.addListener(this.listener);
          }
          const subscription = {
            id: this.pubNubInstance.getSubscriptionId(),
            channels,
            listener: this.listener,
          };
          this.pubNubInstance.subscriptions = [...this.pubNubInstance.subscriptions, subscription];
        } catch (err) {
          // Swallow error; it's unrecoverable and non-critical functionality
        }
      }
    }

    return new BlPubnub();
  });
